import React from "react";
import { Dialog, DialogContent, DialogActions, Button } from "@material-ui/core";

export function ConfirmModal({cancelCallback, show, confirmCallback, title, description, fullWidth}) {
    if(!show) return <></>
    return (
    <Dialog onClose={() => { }} open={show} fullWidth={fullWidth}>
        <DialogContent>
        <h5>{title}</h5>
            {description}
        </DialogContent>
        <DialogActions>
            <Button variant="contained" className="gray-button uvp-button" onClick={cancelCallback} style={{marginRight:"10px"}}>No</Button>
            <Button variant="contained" className="green-button uvp-button" onClick={confirmCallback}>Yes</Button>
        </DialogActions>
    </Dialog>)
}